import { render, staticRenderFns } from "./TableCustomers.vue?vue&type=template&id=1d42ead7&"
import script from "./TableCustomers.vue?vue&type=script&lang=js&"
export * from "./TableCustomers.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomers.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d42ead7')) {
      api.createRecord('1d42ead7', component.options)
    } else {
      api.reload('1d42ead7', component.options)
    }
    module.hot.accept("./TableCustomers.vue?vue&type=template&id=1d42ead7&", function () {
      api.rerender('1d42ead7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableCustomers.vue"
export default component.exports